<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiLogin } from "@mdi/js";
export default {
  name: "MdiLogin",
  data() {
    return {
      svgPath: mdiLogin,
    };
  },
};
</script>
